<template>
  <button
    :id="empty?.id"
    type="button"
    @click="!empty?.disabled && emit('buttonClick')"
    class="relative block w-full rounded-md border-2 border-dashed p-2 text-center focus:outline-none border-neutral-200 hover:border-neutral-300 active:border-neutral-400 dark:border-neutral-700 dark:hover:border-neutral-600 dark:active:border-neutral-500"
    :class="empty?.disabled ? 'opacity-50 pointer-events-none' : ''"
  >
    <span class="block text-sm sm:text-base font-medium">
      <component v-if="empty?.icon" :is="empty.icon" />
      {{ empty?.text }}
      <slot />
    </span>
  </button>
</template>

<script setup lang="ts">
import { IconPlaceholder } from "@tabler/icons-vue";

interface Props {
  empty?: {
    id?: string;
    icon?: typeof IconPlaceholder;
    text?: string;
    disabled?: boolean;
  };
}

interface Events {
  (e: "buttonClick", v: void): void;
}

defineProps<Props>();
const emit = defineEmits<Events>();
</script>
